import { useTranslation } from '../i18n';
import NavBarNB from '../components/NavBarNB';
import FooterNB from '../components/FooterNB';
import ContactForm from '../components/ContactForm';
import FaqSection from '../components/FaqSection';
import { useNbTheme } from '../hooks/useNbTheme';

export default function SupportPage() {
  const { t } = useTranslation();
  const { colors } = useNbTheme();

  return (
    <div className="min-h-screen flex flex-col bg-nb-cream">
      <NavBarNB />
      <main className="flex-1 max-w-2xl mx-auto px-4 py-16 text-center">
        <h1
          className="text-3xl font-bold font-nb mb-6"
          style={{ color: colors.textPrimary }}
        >
          {t('pages.support')}
        </h1>
        <div className="mt-6 flex flex-col gap-6">
          <ContactForm variant="support" />
          <FaqSection />
        </div>
      </main>
      <FooterNB />
    </div>
  );
}
